export default {
  // Get Record Binders
  GET_RECORD_BINDERS_REQUESTED: 'GET_RECORD_BINDERS_REQUESTED',
  GET_RECORD_BINDERS_SUCCESS: 'GET_RECORD_BINDERS_SUCCESS',
  GET_RECORD_BINDERS_FAILURE: 'GET_RECORD_BINDERS_FAILURE',

  // Get Record History
  GET_RECORD_HISTORY_REQUESTED: 'GET_RECORD_HISTORY_REQUESTED',
  GET_RECORD_HISTORY_SUCCESS: 'GET_RECORD_HISTORY_SUCCESS',
  GET_RECORD_HISTORY_FAILURE: 'GET_RECORD_HISTORY_FAILURE',

  // Get Record History Details
  GET_RECORD_HISTORY_DETAILS_REQUESTED: 'GET_RECORD_HISTORY_DETAILS_REQUESTED',
  GET_RECORD_HISTORY_DETAILS_SUCCESS: 'GET_RECORD_HISTORY_DETAILS_SUCCESS',
  GET_RECORD_HISTORY_DETAILS_FAILURE: 'GET_RECORD_HISTORY_DETAILS_FAILURE',

  // Search Record Binders
  SEARCH_RECORD_BINDERS: 'SEARCH_RECORD_BINDERS',

  // Filter Record Binders
  FILTER_RECORD_BINDERS: 'FILTER_RECORD_BINDERS',

  // Filter Record History
  FILTER_RECORD_HISTORY: 'FILTER_RECORD_HISTORY',

  // Sort Record Binders
  SORT_RECORD_BINDERS: 'SORT_RECORD_BINDERS',

  // Set Current Record Binder
  SET_CURRENT_RECORD_BINDER: 'SET_CURRENT_RECORD_BINDER',

  // Reset Props
  RESET_RECORD_BINDER_PROPS: 'RESET_RECORD_BINDER_PROPS',
  RESET_RECORD_BINDER_ERROR_PROPS: 'RESET_RECORD_BINDER_ERROR_PROPS',

  // Bin Record Binders
  GET_BIN_RECORD_BINDERS_REQUESTED: 'GET_BIN_RECORD_BINDERS_REQUESTED',
  GET_BIN_RECORD_BINDERS_SUCCESS: 'GET_BIN_RECORD_BINDERS_SUCCESS',
  GET_BIN_RECORD_BINDERS_FAILURE: 'GET_BIN_RECORD_BINDERS_FAILURE',
  SEARCH_BIN_RECORD_BINDERS: 'SEARCH_BIN_RECORD_BINDERS',
  RESET_RECORD_BINDER_BIN_PROPS: 'RESET_RECORD_BINDER_BIN_PROPS',

  // Add Record
  ADD_RECORD_REQUESTED: 'ADD_RECORD_REQUESTED',
  ADD_RECORD_SUCCESS: 'ADD_RECORD_SUCCESS',
  ADD_RECORD_FAILURE: 'ADD_RECORD_FAILURE',

  // Update Record
  UPDATE_RECORD_REQUESTED: 'UPDATE_RECORD_REQUESTED',
  UPDATE_RECORD_SUCCESS: 'UPDATE_RECORD_SUCCESS',
  UPDATE_RECORD_FAILURE: 'UPDATE_RECORD_FAILURE',

  // Delete Record
  DELETE_RECORD_REQUESTED: 'DELETE_RECORD_REQUESTED',
  DELETE_RECORD_SUCCESS: 'DELETE_RECORD_SUCCESS',
  DELETE_RECORD_FAILURE: 'DELETE_RECORD_FAILURE',

  // Upload Record Attachment
  UPLOAD_RECORD_ATTACHMENT_REQUESTED: 'UPLOAD_RECORD_ATTACHMENT_REQUESTED',
  UPLOAD_RECORD_ATTACHMENT_SUCCESS: 'UPLOAD_RECORD_ATTACHMENT_SUCCESS',
  UPLOAD_RECORD_ATTACHMENT_FAILURE: 'UPLOAD_RECORD_ATTACHMENT_FAILURE',
  CLEAR_RECORD_ATTACHMENT_UPLOAD: 'CLEAR_RECORD_ATTACHMENT_UPLOAD',
  CLEAR_ALL_RECORD_ATTACHMENT_UPLOADS: 'CLEAR_ALL_RECORD_ATTACHMENT_UPLOADS',
};
